export const WEEKDAYS = [
  'montag',
  'dienstag',
  'mittwoch',
  'donnerstag',
  'freitag',
  'samstag',
  'sonntag',
  'feiertag',
] as const;

export type Weekday = (typeof WEEKDAYS)[number];
